import React from 'react';
import { Component } from "react";
import { API_URL } from '../urls';
require('odatajs');

class ControlPreviewText extends Component {
  constructor(props) {
    super(props);
    this.state = {
        error: null,
        pending: true,
        control_type: props.control_type,
        control_id: props.control_id
    };
  }
  componentDidMount() {
    let token = localStorage.getItem('_TOKEN_AUTH');
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: "Bearer " + token };
    var request = {
        requestUri: API_URL + "PageControls(" + this.state.control_id + ")",
        method: 'GET',
        headers: headers
    };
    window.odatajs.oData.request(
        request,
        (data, response) => {
          	this.setState({
	            pending: false,
        	    data
	        });
            },
            (error) => {
                if(error.response.statusCode === 401){
                  window.location.href = "/login";
                }
          	this.setState({
	            pending: false,
        	    error
	        });
            }
        );
  }

    render() {
        if(this.state.pending){
          return (<div />);
        }

        if(this.state.error){
            return (<div >{this.state.error}</div>);

        }

        const tag = (this.state.data.size == null) ? "div" :this.state.data.size;
        return ( <tag>{this.state.data.Title}</tag>);
    }
}

export default ControlPreviewText;